import { Skeleton, Stack } from '@mui/material';
import React from 'react';

const LoadingItem = () => {
  return (
    <Stack maxWidth={'225px'}>
      <Skeleton variant="rounded" width={'225px'} height={111} />
    </Stack>
  );
};

const LoadingSummary = () => {
  return (
    <Stack flexDirection={'row'} flexWrap={'wrap'} gap={'8px'}>
      <LoadingItem />
      <LoadingItem />
      <LoadingItem />
      <LoadingItem />
      <LoadingItem />
    </Stack>
  );
};

export default LoadingSummary;